import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageHeaderStoreService {
  private readonly titleSignal = signal<string>('');

  public setTitle(title: string) {
    this.titleSignal.set(title);
  }

  title = this.titleSignal.asReadonly();
}
